
Grid = window.Grid || {};

Grid.AgCellRenderer = function(field, $ctrl, $translate, $filter) {

	var basicViewFields = ['Field','TextField','DateField','IntervalField','UrlField',
									'CalculatedField','TextCalculatedField', 'ExpressionField'];
									
	var def = {
		width: 150
	};
	if (field.client && field.client.grid && field.client.grid.width) def.width = field.client.grid.width;

	var visibilityFilter = function(cellRenderer) {
		return function(params) {
			if (params.data.has_perm && params.data.has_perm(field.viewperm)) {
				return cellRenderer(params) || '';
			}
			return '<i class="fa fa-eye-slash"></i>';
		}
	}
	
	var field_type = field.type;
	if (field.client && field.client.widget && field_type != "SequenceField") field_type = field.client.widget;

	if (field_type == 'ReferenceField') {
		//def.valueGetter = 'data.'+field.name+'.__title';
		//def.valueGetter = visibilityFilter(function(params) {return (params.data[field.name]||{}).__title;})
		def.cellRenderer = visibilityFilter(function(params) {return (params.data[field.name]||{}).__title;})
	} else if (basicViewFields.indexOf(field_type) > -1) {
		// nothing
		def.cellRenderer = visibilityFilter(function(params) {return params.data[field.name];})
	} else if (field_type == 'DateTimeField' || field_type == 'TimeField') {
		if (field.client && field.client.display=='shorttime') {
			def.cellRenderer = visibilityFilter(function(params) {
				return (params.data[field.name]||'').replace(/:\d\d(\.\d*)?$/, '');
			})
		} else {
			def.cellRenderer = visibilityFilter(function(params) {return params.data[field.name];})
		}
	} else if (field_type == 'CurrencyField' || field_type == 'CurrencyCalculatedField') {
		def.cellRenderer = visibilityFilter(function(params) {
			var values = [];
			for (var currency in params.data[field.name]) values.push(currency + ' ' + (params.data[field.name][currency]||0).toFixed(2));
			return values.join(' + ');
		})
		def.cellClass="text-right"
	} else if (field_type == 'TagField') {
		def.cellRenderer = visibilityFilter(function(params) {
			var values = [];
			for (var i in params.data[field.name]) values.push(params.data[field.name][i]);
			return values.join(', ');
		})
	} else if (field_type == 'BooleanField' || field_type == 'BooleanCalculatedField') {
		def.cellRenderer = visibilityFilter(function(params) {
			return params.data[field.name]? '<i class="fa fa-check"></i>' : '<i class="fa fa-minus"></i>'
		})
	} else if (field_type == 'WorkflowField') {
		def.cellRenderer = visibilityFilter(function(params) {
			//var original = field.workflow.states[params.data[field.name]].name || params.data[field.name];
			var original = field.dictionary[params.data[field.name]] || params.data[field.name];
			return $translate.instant(original);
		})
	} else if (field_type == 'DictionaryField') {
		def.cellRenderer = visibilityFilter(function(params) {
			var original = params.data[field.name];
			for (var i=0; i<field.dictionary.length; i++) {
				if (field.dictionary[i][0] == params.data[field.name]) {
					original = field.dictionary[i][1];
					break;
				}
			}
			return $translate.instant(original);
		})
	} else if (field_type == 'DecimalField' || field_type == 'DecimalCalculatedField' || field_type == 'IntField') {
		var client = field.client || {};
		var numberpl = $filter('numberpl');
		def.cellRenderer = visibilityFilter(function(params) {
			return (client.prefix||'') + ' ' + numberpl(params.data[field.name]) + ' ' + (client.suffix||'');
		})
		def.cellClass="text-right"
	} else if (field_type == 'SequenceField') {

		def.cellRenderer = visibilityFilter(function(params) {return params.data[field.name];})
		def.rowDrag = true;
		$ctrl.gridOptions.rowDragManaged = false;  // default
		//$ctrl.gridOptions.animateRows = false;
		$ctrl.dragFieldName = field.name;

	} else {
		def.cellRenderer = visibilityFilter(function(params) {
			params.$scope.fields = params.$scope.fields || {};
			params.$scope.fields[field.name] = field;
			return '<div field-value="fields.'+field.name+'" object="data"></div>';
		})
		// compile rows
		$ctrl.gridOptions.angularCompileRows = true;
	}
	
	return def;
}

Grid.makeGridOptions = function(gridOptions, $translate) {

	return angular.extend({
			headerHeight: 30,
			rowHeight: 30,
			colWidth: 150,
			enableColResize: true,
			icons: {
	            // use font awesome for menu icons
	            menu: '<i class="fa fa-bars"/>',
	            filter: '<i class="fa fa-filter"/>',
	            sortAscending: '<i class="fa fa-caret-up"/>',
	            sortDescending: '<i class="fa fa-caret-down"/>',
	            // use some strings from group
	            groupExpanded: '<img src="minus.png" style="width: 15px;"/>',
	            groupContracted: '<img src="plus.png" style="width: 15px;"/>',
				columnMovePin: '<i class="fa fa-thumb-tack"/>', // when column is to the left, before it gets pinned
				columnMoveAdd: '<i class="fa fa-plus"/>', // when adding a column
				columnMoveHide: '<i class="fa fa-minus"/>', // when removing a column
				columnMoveMove: '<i class="fa fa-arrows-h"/>', // when moving a column
				columnMoveLeft: '<i class="fa fa-caret-left"/>', // when moving and scrolling left
				columnMoveRight: '<i class="fa fa-caret-right"/>', // when moving and scrolling right
	        },
	        suppressNoRowsOverlay: true,
	        suppressLoadingOverlay: true,
			//suppressDragLeaveHidesColumns: true,
			localeText: {
				// for number filter
				equals: $translate.instant('Equals'),
				lessThan: $translate.instant('Less than'),
				greaterThan: $translate.instant('Greater than'),

				// for text filter
				contains: $translate.instant('Contains'),
				startsWith: $translate.instant('Starts with'),
				endsWith: $translate.instant('Ends with'),

				filterOoo: $translate.instant('filter...'),
			}
		}, gridOptions);

}

Grid.AgGridComponent = {
	template: '<div ag-grid="gridCtrl.gridOptions" set-to-parent-height class="{{gridCtrl.agClass}}" style="display:none; flex-grow: 1;"></div>',
	transclude: false,
	bindings: {
		listController: '=',
		selectAction: '&',
		agClass: '@',
		cellClassRules: '=',
		mergeGridColumnDefs: '=',
	},
	controllerAs: 'gridCtrl',
	controller: function($injector, $scope, $filter, $rootScope, $timeout, $translate, $q, pinesNotifications, GridHelpers) {
	
		var self = this;
		this.Class = this.listController.Class;
		
		this.agClass = this.agClass || 'ag-bootstrap'
		
		this.prefs = null;  // the grid prefs object in the future
		this.objects = null;

		this.pinesNotifications = pinesNotifications;
		
		this.gridOptions = GridHelpers.makeGridOptions({
			enableServerSideSorting: true,
			suppressCellSelection: true,  // do not click individual cells
			rowSelection: 'single',
			angularCompileRows: false,  // sloow
			rowData: null,
			columnDefs: null,
			animateRows: true,
		});

		this.dragFieldName = null;
		
		this.getColumnDefs = function() {
			var fields = this.Class.get_fields('list');
			
			var defs = [];
			for (var i in fields) {
				var field = fields[i];
				// check static perm
				if (!this.Class.perms[field.listperm]) continue;
				var def = {
					colId: field.name,
					field: field.name,
					fieldInfo: field,  // custom information for cellTemplate
					headerName: $filter('translate')(field.title),
					headerTooltip: $filter('translate')(field.title),
					hide: false,
					//enableHiding: false,
					//enableSorting: true,
					//minWidth: 70,
					//cellTemplate: '<div class="ui-grid-cell-contents" title="TOOLTIP" field-value="{object:row.entity, field:col.colDef.fieldInfo}"></div>'
				};

				angular.extend(def, GridHelpers.makeAgCellRenderer(field, self));
				
				// merge colDefs from main.js
				if (this.mergeGridColumnDefs) {
					for (var j=0; j<this.mergeGridColumnDefs.length; j++) {
						if (this.mergeGridColumnDefs[j].colId == def.colId) {
							angular.extend(def, this.mergeGridColumnDefs[j]);
						}
					}
				}

				defs.push(def);
			}
			return defs;
		}
		
		this.gridOptions.columnDefs = this.getColumnDefs();
		// compile angular for unusual fields
		for (var ci=0; ci<this.gridOptions.columnDefs.length; ci++) {
			if (this.cellClassRules) this.gridOptions.columnDefs[ci].cellClassRules = this.cellClassRules
		}

		this.gridOptions.getRowNodeId = function(data) { return data.__rec_id || data.__id }
		
		this.gridOptions.onGridReady = function() {
			// open target object
			self.gridOptions.api.addEventListener('rowClicked', function(event){
				self.selectAction({object: event.data, event: event.event});
			});
			// set sort model - update col icons
			var sort = self.listController.params.sort;
			var sortModel = [];
			for (var i=0; i<sort.length; i++) {
				var info = self.getSortModel(sort[i]);
				if (info) sortModel.push(info);
			}
			self.gridOptions.api.setSortModel(sortModel);
			// sorting
			self.gridOptions.api.addEventListener('sortChanged', function(event){
				console.log('sortChanged', event);
				var sortmodel = self.gridOptions.api.getSortModel()
				var sort = [];
				for (var i=0; i<sortmodel.length; i++) {
					var info = sortmodel[i];
					var sort_expr = self.getSortExpr(info);
					if (sort_expr) sort.push(sort_expr);
				}
				if (sort.length == 0) sort.push(self.Class.default_sort);
				self.updateSort(sort);

				// enable/disable row dragging
				self.gridOptions.api.setSuppressRowDrag(self.listController.params.sort[0] != self.dragFieldName)
			});
			
			//self.gridOptions.api.addEventListener('columnVisible columnPinned afterColumnResized columnMoved', function(event){
			self.gridOptions.api.addEventListener('columnResized', function(event){
				self.colState = self.gridOptions.columnApi.getColumnState();
			});
			self.gridOptions.api.addEventListener('columnMoved', function(event){
				//console.log('columnChanged', event);
				self.colState = self.gridOptions.columnApi.getColumnState();
				//self.saveColState();
			});
			self.gridOptions.api.addEventListener('columnPinned', function(event){
				self.colState = self.gridOptions.columnApi.getColumnState();
			});
			self.gridOptions.api.addEventListener('columnVisible', function(event){
				self.colState = self.gridOptions.columnApi.getColumnState();
			});
			self.gridOptions.api.addEventListener('dragStarted', function(event){
				console.log('dragStarted', event);
			});
			self.gridOptions.api.addEventListener('rowDragMove', function(event){
				//console.log('rowDragMove', event);
				self.onRowDragMove(event)
			});
			self.gridOptions.api.addEventListener('rowDragEnd', function(event){
				console.log('rowDragEnd', event);
				self.onRowDragEnd(event)
			});




			self.colState = self.gridOptions.columnApi.getColumnState();

		};
		
		this.updateSort = function(sort) {
			self.listController.params.sort = sort;
			self.listController.reload();
		}
		
		this.getSortExpr = function(info) {
			var fields = this.Class.get_fields('list');
			for (var i in fields) {
				if (fields[i].name == info.colId) {
					return (info.sort=='desc'?'-':'') + fields[i].sort_expr;
				}
			}
			return null;
		}
		
		this.getSortModel = function(sort_expr) {
			var direction = 'asc';
			if (sort_expr[0] == '-') {
				sort_expr=sort_expr.substr(1);
				direction = 'desc';
			}
			var fields = this.Class.get_fields('list');
			for (var i in fields) {
				if (fields[i].sort_expr == sort_expr) {
					return {colId: fields[i].name, sort: direction};
				}
			}
			return null;
		}
		
		//$scope.$watch(function(){return self.listController.objects}, function(objects){
		self.listController.getPage.subscribe(function(objects){
			self.gridOptions.api.setRowData(objects);
			self.objects = objects;
		});
		
		// load column state
		this.listController.promises.prefs.then(function(prefs){
			self.prefs = prefs;
			var state = prefs.getItem('colState');
			if (state && state.length == self.gridOptions.columnDefs.length) {
				// reapply saved state
				self.colState = state;
				gridCtrl.gridOptions.columnApi.setColumnState(state);
			}
		});
		this.getColumnDef = function(colId) {
			for (var i in self.gridOptions.columnDefs) {
				var def = self.gridOptions.columnDefs[i];
				if (def.colId == colId) return def;
			}
		}
		this.saveColState = function(){
			if (self.colState && self.prefs) {
				self.gridOptions.columnApi.setColumnState(self.colState);
				return self.prefs.setItem('colState', self.colState);
			}
			$q.when(true);
		}

		this.origDataIndices = null
		this.onRowDragMove = function (event) {
			var movingNode = event.node;
			var overNode = event.overNode;
		
			var rowNeedsToMove = movingNode !== overNode;
		
			if (rowNeedsToMove) {
				self.gridOptions.animateRows = true;
				self.gridOptions.deltaRowDataMode = true;
				// the list of rows we have is data, not row nodes, so extract the data
				var movingData = movingNode.data;
				var overData = overNode.data;
		
				var fromIndex = self.objects.indexOf(movingData);
				var toIndex = self.objects.indexOf(overData);

				if (!self.origDataIndices) {
					self.origDataIndices = {}
					for (var i=0; i<self.objects.length; i++) {
						self.origDataIndices[self.objects[i].__id] = i;
					}
				}
		
				//var newStore = self.objects.slice();
				moveInArray(self.objects, fromIndex, toIndex);
		
				//self.objects = newStore;
				self.gridOptions.api.setRowData(self.objects);
		
				self.gridOptions.api.clearFocusedCell();
			}
		
			function moveInArray(arr, fromIndex, toIndex) {
				var element = arr[fromIndex];
				arr.splice(fromIndex, 1);
				arr.splice(toIndex, 0, element);
			}
		}

		this.onRowDragEnd = function (event) {
			self.gridOptions.animateRows = false;
			self.gridOptions.deltaRowDataMode = false;
			var movingNode = event.node;
			var overNode = event.overNode;
			var rowNeedsToMove = self.origDataIndices[movingNode.data.__id] !== event.overIndex;
			if (!rowNeedsToMove) return;
			
			var mode = self.origDataIndices[movingNode.data.__id] > event.overIndex ? 'before' /* up */: 'after' /* down */;
			var targetObj = self.objects[event.overIndex + (mode == "before" ? 1 : -1)];
			movingNode.data[self.dragFieldName + '__place']({target_id: targetObj.__id, mode:mode}).then(function(){
				self.listController.reload();
			}, function(error){
				self.pinesNotifications.notify({
					title: 'An error occured while reordering',
					text: error.data? error.data.message: error,
					type: 'error'
				});
				self.listController.reload();
			})
			self.origDataIndices = null;
		}
		
		/*$rootScope.$watch('elementHeight', function(h){
			$timeout(function(){
				if (self.gridOptions.api) {  // grid might not exist by then
					self.gridOptions.api.doLayout()
				}
			});
		}, true);*/
		
		
		// register options screen
		self.listController.options.push({'title': $translate.instant('Columns'), 'templateUrl': 'framework/partials/grid/options-columns.html', grid: self, save: function(){return self.saveColState()}});
		
		window.gridCtrl = self;
		
	}
}



